/* SubscriptionStatuses.js */
/* @author: anghello */

module.exports = Object.freeze({
  STATUS: {
    NONE: 1,
    ACTIVE_FREE: 2,
    ACTIVE_MONTHLY: 3,
    ACTIVE_YEARLY: 4,
    PENDING: 5,
    EXPIRED: 7,
    CANCELED: 9
  },
  TYPE: {
    NONE: 0,
    FREE: 1,
    PLUS: 2,
    PREMIUM: 3,
    MAX: 4
  },
  REGULARITY: {
    NONE: 0,
    FREE: 1,
    MONTHLY: 2,
    YEARLY: 3
  }
});